export class CashReceiptAttachmentRawDto {
    description: string;
    fileDataBase64: string; // 	Required
    fileExtension: string; // Required
    fileName: string; // Required
    fileStoreId: number;
}
